module.exports = __webpack_public_path__ + "static/media/tech-hero.bd5d1cd2.jpg";